import { FC } from "react";
import Image from "next/legacy/image";
import gearsImage from "@modules/for-you/assets/images/gears-illustration.svg";
import { useBreakpoints } from "@common/hooks";
import { Typography } from "@earned/core";

const ReportsInterimState: FC = () => {
  const { isMobile } = useBreakpoints();

  return (
    <div className="flex flex-1 flex-col justify-between">
      <div className="max-w-[600px] space-y-5 pb-7">
        <Typography variant="title-2xl" color="primary" weight="medium">
          Your advisor is working on your personalized advice
        </Typography>
        <Typography variant="body-lg" color="secondary">
          Your reports will appear here when they are complete. Please contact
          your advisor if you have any questions.
        </Typography>
      </div>
      <div className="flex justify-end">
        <Image
          src={gearsImage}
          height={isMobile ? 117 : 282}
          width={isMobile ? 180 : 359}
        />
      </div>
    </div>
  );
};

export default ReportsInterimState;
